import React from 'react';

import { InlineNotification } from '@blueprint/ui';

export const InlineNotificationComponent = ({ title, content, id }) => {
    return (
        <InlineNotification title={title} variant='error'>
            <span id={id}>{content}</span>
        </InlineNotification>
    );
};
